import type { FC } from "react"
import React from "react"

import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"

import { ConfirmModal } from "~/components/ConfirmModal"

import {
  attemptedPhaseTransitionState,
  phasesToResetState,
  regressionOperationsFor,
  useCancelPhaseTransition,
  useEnterPhase,
} from "../state/phase"

const ConfirmPhaseTransitionModal_Internal: FC = () => {
  const attemptedPhase = useRecoilValue(attemptedPhaseTransitionState)
  const enterPhase = useEnterPhase()
  const phasesToReset = useRecoilValue(phasesToResetState)
  const { t } = useTranslation()
  const cancel = useCancelPhaseTransition()

  return (
    <>
      {attemptedPhase && (
        <ConfirmModal
          Heading={() => (
            <h4>
              Going back to the <span>{attemptedPhase}</span> phase will result
              in the following:
            </h4>
          )}
          onClose={cancel}
          onSubmit={() => attemptedPhase && enterPhase(attemptedPhase)}
          Descriptions={() => (
            <>
              {phasesToReset.map((phase) => {
                const { desc } = regressionOperationsFor[phase]

                return (
                  <React.Fragment key={phase + `phaseRegressDesc`}>
                    {desc && <li>{`${t(desc)}`}</li>}
                  </React.Fragment>
                )
              })}
            </>
          )}
        />
      )}
    </>
  )
}
export const ConfirmPhaseTransitionModal = React.memo(
  ConfirmPhaseTransitionModal_Internal,
)
